var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubcontractorManagementColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00205b;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #545859;\n      }\n\n      .cls-3 {\n        fill: #ed8b00;\n      }\n\n      .cls-4 {\n        fill: #5e8ab4;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #d9d9d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    "data-name": "For Color Icons",
    className: "cls-6",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Subcontractor_Management_-_White",
    "data-name": "Subcontractor Management - White"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27,
    y: 58.93,
    width: 130,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m148.01,51.96H36.87c-8.76,0-15.88,7.12-15.88,15.88v79.39c0,8.76,7.12,15.88,15.88,15.88h111.14c8.76,0,15.88-7.12,15.88-15.88v-79.39c0-8.76-7.12-15.88-15.88-15.88Zm3.97,95.26c0,2.18-1.79,3.97-3.97,3.97H36.87c-2.18,0-3.97-1.79-3.97-3.97v-79.39c0-2.18,1.79-3.97,3.97-3.97h111.14c2.18,0,3.97,1.79,3.97,3.97v79.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.1,147.54c6.84-1.77,11.91-7.99,11.91-15.38V52.78c0-8.76-7.12-15.88-15.88-15.88H51.99c-7.39,0-13.61,5.07-15.38,11.91h15.38s95.35,0,95.35,0c11.61.22,19.25,5.68,19.76,17.65v81.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.53,115.47h-15.88c-10.97,0-19.85,8.88-19.85,19.85,0,2.18,1.79,3.97,3.97,3.97h47.63c2.18,0,3.97-1.79,3.97-3.97,0-10.97-8.88-19.85-19.85-19.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m72.59,107.53c8.77,0,15.88-7.11,15.88-15.88h-31.75c0,8.77,7.11,15.88,15.88,15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m134.12,79.74h-19.85c-3.3,0-5.95,2.65-5.95,5.95s2.65,5.95,5.95,5.95h19.85c3.3,0,5.95-2.65,5.95-5.95s-2.65-5.95-5.95-5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m134.12,98.56h-19.85c-3.3,0-5.95,2.65-5.95,5.95s2.65,5.95,5.95,5.95h19.85c3.3,0,5.95-2.65,5.95-5.95s-2.65-5.95-5.95-5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.06,90.42h31.07c1.61,0,2.91-1.3,2.91-2.91s-1.3-2.91-2.91-2.91h-.02c-.34-5.51-3.57-10.26-8.18-12.73l-3.45,6.91v-6.8c0-1.61-1.3-2.91-2.91-2.91h-1.94c-1.61,0-2.91,1.3-2.91,2.91v6.8l-3.45-6.91c-4.61,2.48-7.84,7.22-8.18,12.73h-.02c-1.61,0-2.91,1.3-2.91,2.91s1.3,2.91,2.91,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m134.12,117.38h-19.85c-3.3,0-5.95,2.65-5.95,5.95s2.65,5.95,5.95,5.95h19.85c3.3,0,5.95-2.65,5.95-5.95s-2.65-5.95-5.95-5.95Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcontractorManagementColor);
export default __webpack_public_path__ + "static/media/SubcontractorManagement_Color.12501759654615dbe0d98216d0868e94.svg";
export { ForwardRef as ReactComponent };